import React from 'react';

import cookie from 'react-cookies'

import backImage from '../img/modal-close.svg';

import './Modal.css'

export default class Modal extends React.Component {
  state = {
    isUserAgree: cookie.load('isUserAgree')
  }

  close() {
    cookie.save('isUserAgree', true, { path: '/' });

    this.setState({
      isUserAgree: cookie.load('isUserAgree')
    })
  }

  render() {
    if (this.state.isUserAgree) return null;

    const { text, buttonText } = this.props;

    return (
      <div className="modalInfo">
        <p
          className="modalInfo__text">
          {text}
        </p>
        
        <div className="modalInfo__btn">
          <button 
            onClick={this.close.bind(this)}>

            {buttonText}
          </button>
        </div>
            
        <img 
          className='modalInfo__close'
          onClick={this.close.bind(this)}
          src={backImage}
          alt="close modal"
        />
      </div>
    )
  }
}
